<template>
  <component :is="component" v-bind="{ ...$attrs, ...$props }" v-on="$listeners" />
</template>

<script>
import basic from './BlockContacts.vue';
import { mapGetters } from 'vuex';
const FenicheBlockContacts = () => import(/* webpackChunkName: "feniche" */ "@/process/feniche/components/response/blocks/BlockContacts.vue");

export default {
  name: 'process-response-block-contacts',
  components: {
    default: basic,
    feniche: FenicheBlockContacts
  },
  computed: {
    ...mapGetters('process', ['getProcessName']),

    component() {
      if (this.getProcessName == 'feniche') {
        return this.getProcessName
      } else {
        return 'default'
      }
    }
  }
}
</script>
